import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { serializeProduct } from "lib/utils/api/serializers";
import { ProductDecorator, ProductFullDecorator } from "lib/decorators/index";

export default new (class ProductsRepository extends BaseRepository {
  search(params = {}) {
    return this.api.post("/products/search", params).map(({ data: { records, aggregations, meta } }) => ({
      records: st.api.dejsonapinize(records.data, records.included).map((order) => {
        // console.log(order.expire_at);
        // console.log(order.expire_from);
        return new ProductDecorator(order);
      }),
      aggregations,
      meta,
    }));
  }

  find(id) {
    return this.api
      .get(`/products/${id}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((product) => new ProductFullDecorator(product));
  }

  create(data, { useFormData = false } = {}) {
    let payload = {
      product: serializeProduct(data),
    };
    if (useFormData) {
      payload = st.api.toFormData(payload);
    }
    return this.api
      .post(`/products`, payload)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((product) => new ProductFullDecorator(product));
  }

  update(data, initialData, { useFormData = false } = {}) {
    let payload = {
      product: serializeProduct(data, initialData),
    };
    if (useFormData) {
      payload = st.api.toFormData(payload);
    }
    return this.api
      .put(`/products/${data.id}`, payload)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((product) => new ProductFullDecorator(product));
  }

  delete(id) {
    return this.api.delete(`/products/${id}`);
  }

  translate(productId, langFrom, langTo) {
    return this.api
      .post(`/products/${productId}/translate`, { language_from: langFrom, language_to: langTo })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((product) => {
        return new ProductFullDecorator(product)
      });
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/ProductsRepository.js